var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"autoplay":"true","muted":"true"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.url,"type":("video/" + (_vm.image.extension))}})])}
var staticRenderFns = []

export { render, staticRenderFns }